export const parseLuxuryMerchants = (value?: string | null): string[] => {
  if (!value) {
    return [];
  }

  return value
    .split(",")
    .map((merchantId) => merchantId.trim())
    .filter((merchantId) => merchantId.length > 0);
};

export const isLuxuryMerchantId = (
  merchantId: string | null | undefined,
  luxuryMerchants: string[],
): boolean => {
  if (!merchantId) {
    return false;
  }

  return luxuryMerchants.includes(merchantId);
};
